import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ReportData, ReportMetadata } from "../models/report.model";

@Injectable({
  providedIn: "root"
})
export class ReportingService {
  private apiUrl = `/v1/reports`;

  constructor(private http: HttpClient) {}

  getAvailableReports(): Observable<ReportMetadata[]> {
    return this.http.get<any>(`${this.apiUrl}/list`);
  }

  getReportMetadata(reportId: string): Observable<ReportMetadata> {
    return this.http.get<ReportMetadata>(`${this.apiUrl}/list/${reportId}`);
  }

  generateReport(reportId: string, filters: { [key: string]: any }): Observable<ReportData> {
    let params = new HttpParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value.toString());
      }
    });

    return this.http.get<ReportData>(`${this.apiUrl}/generate/${reportId}`, { params });
  }
}
